/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Button from '../buttons/Button';
import Chevron from '../icons/Chevron';
import Image from '../partials/Image';
import Body from '../typography/Body';
import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/cards/person.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    roles: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

function PersonCard({ item = null, roles = null, className = null, ...props }) {
    const {
        name = null,
        title = null,
        employer = null,
        bio = null,
        image = null,
        url = null,
    } = item || {};

    const hasBio = useMemo(() => bio !== null && bio !== '', [bio]);

    const titleText = useMemo(() => {
        if (title !== null && employer !== null) {
            return `${title}, ${employer}`;
        }
        if (title !== null) {
            return title;
        }
        if (employer !== null) {
            return employer;
        }
        return null;
    }, [title, employer]);

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            href={url}
            {...props}
        >
            <Image
                className={styles.image}
                image={image}
                size="medium"
                filtered
                filteredHover={url !== null}
                rounded
                square
            />
            <div className={styles.content}>
                <Title className={styles.name}>{name}</Title>
                {titleText !== null && roles === null ? (
                    <Text className={styles.title}>{titleText}</Text>
                ) : null}
                <Text className={styles.roles}>
                    {(roles || [])
                        .map(({ label = null }) => label || null)
                        .filter((l) => l !== null)
                        .join(', ')}
                </Text>
                <Body className={styles.bio} body={bio} />
                {url !== null && hasBio ? <Chevron className={styles.chevron} /> : null}
            </div>
        </Button>
    );
}

PersonCard.propTypes = propTypes;

export default PersonCard;
